import ApiService from '@/services/api'
import { defineStore } from 'pinia'

const ENDPOINT = '/events/'
const ITEM_ID  = 'eve_id'

export const useEventStore = defineStore('events', {
  state: () => ({
    item: { eve_custom_fields: {}, eve_sta_id: 'GEN01', _pivot: { users: [], equipments: [] } },
    itemList: [],
    metaItems: null
  }),
  getters: {},
  actions: {
    fetchItem (id, options) {
      return new Promise((resolve, reject) => {
        options = (options) ? '/' + options : ''
        if (id && id > 0) {
          ApiService.get(ENDPOINT + id + options).then((response) => {
            if (!response.data.data.eve_custom_fields || Object.prototype.toString.call(response.data.data.eve_custom_fields) === '[object Array]') {
              response.data.data.eve_custom_fields = {}
            }
            this.SET_ITEM(response.data.data)
            resolve(this.item)
          }).catch((error) => { reject(error) })
        } else {
          this.RESET_ITEM()
          resolve(this.item)
        }
      })
    },
    fetchItems (options) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + (options || '')).then((response) => {
          this.metaItems = response.data.meta
          if (Object.prototype.toString.call(response.data.data) === '[object Array]') {
            this.SET_ITEMS(response.data.data)
          }
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    storeItem () {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT, this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    storeMulti (events) {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT + 'multi', events).then((response) => {
          resolve(response.data)
        }).catch((error) => { reject(error) })
      })
    },
    updateItem () {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + this.item[ITEM_ID], this.item).then((response) => {
          this.SET_ITEM(response.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    updateMulti (eveIds, fields) {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + 'multi', { eve_ids: eveIds, ...fields }).then((response) => {
          resolve(response.data)
        }).catch((error) => { reject(error) })
      })
    },
    updatePicture (id, data) {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + id + '/picture', data).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    destroyItem (id) {
      return new Promise((resolve, reject) => {
        this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
        ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then(() => {
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      this.item = item
      if (this.item && (!this.item.eve_custom_fields || Object.prototype.toString.call(this.item.eve_custom_fields) === '[object Array]')) {
        this.item.eve_custom_fields = {}
      }
      this.item._pivot = {}
      this.item._pivot['users']      = (this.item.users) ? [...this.item.users.map(a => a['id'])] : []
      this.item._pivot['equipments'] = (this.item.equipments) ? [...this.item.equipments.map(a => a['equ_id'])] : []

    },
    SET_ITEMS (itemList) {
      itemList.forEach(element => {
        element.eve_custom_fields = (!element.eve_custom_fields) ? {} : element.eve_custom_fields
      })
      this.itemList = itemList
    },
    RESET_ITEM () { this.item = { eve_custom_fields: {}, eve_sta_id: 'GEN01', eve_tty_id: null, eve_duration: '00:00', eve_duration_am: '00:00', eve_duration_pm: '00:00', _pivot: { users: [], equipments: [] }  } }
  }
})
